
import Modal from "react-modal";
import styled from "styled-components";
import { CrossModal } from "./Icon/CrossModal";
import { cosmeticIQApi } from "../service/api";
import { useState } from "react";
import { useData } from "../context/DataProvider";
import Loader from "./Loader";


const ReportModal = ({ isOpen, onClose, type = 'products' ,data}) => {
   const {setData}  = useData();
    const [loading,setLoading] = useState(false);
    
  const handleDelete = async() => {
      
      setLoading(true);
  await cosmeticIQApi.handleDelete(
      {
          id:data?.docId,
          type,
      });
      if(type === 'products')
      {   
          const resp = await cosmeticIQApi.fetchSavedViews();
          setData(prev => ({ ...prev, savedViews: resp }));
      }
      else
      {   
          
          const resp = await cosmeticIQApi.fetchSavedReports();
          setData(prev => ({ ...prev, savedReports: resp }));
      }   
      setLoading(false);
      
      onClose();
  }
  return (
    <Modal
               isOpen={isOpen}
               onRequestClose={()=>{onClose();}} 
               style={{
                   overlay: {  
                       backdropFilter: "blur(5px)", 
                       zIndex:1000,
                       backgroundColor: "rgba(255, 255, 255, 0.4)" 
                   }
                       ,
                   content: {
                       
                       top:'10%',
                       width: "50%",
                    
                       height: "70%",
                       margin: "auto",
                       display: "flex",
                       flexDirection: "column",
                       gap:'90px',
                       background:'none',
                       border: "none",
                       
                       
                   }
               }}
           >
      
     <div style={{display:'flex',justifyContent:'flex-end'}}>
                 <button 
                     onClick={()=>{onClose();}} 
                     style={{
                         position: "absolute", 

                         width:56,
                         background: '#FFFFFF',
                         border: '1.32px solid #FFFFFF4D',
                         boxShadow: '0px 0px 40px 0.66px #0000000F',

                         borderRadius:'64px',
                         height:56,
                         cursor: "pointer",
                         
     
                     }}
                 >
                     <CrossModal/>
                 </button>
                 </div>
           <A>
            <A1>
                <div style={{gap:16,display:'flex',flexDirection:'column'}}>
                <A1Txt>Delete {type === 'products' ? 'product' : 'report'}</A1Txt>
                <A1Txt2>Are you sure you want to delete this {type === 'products' ? 'product' : 'report'}?</A1Txt2>
                </div>
                <Buttons>
                    <Button onClick={onClose} color="#F9F9F9">
                        <A1Txt3>NO</A1Txt3>
                    </Button>
                    <Button onClick={handleDelete} color="linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
">{loading ? <Loader/> : <A1Txt3>YES
</A1Txt3>}</Button>

                </Buttons>


            </A1>
           </A>
    </Modal>
  );
};

export default ReportModal;
const Buttons = styled.div`
display:flex;
gap:8px;`
const Button = styled.button`
cursor:pointer;
align-items:center;
display:flex;
justify-content:center;
border:none;
flex:1;
height: 48px;
angle: 0 deg;
opacity: 1;
border-radius: 64px;
gap: 8px;
padding-top: 6px;
padding-right: 14px;
padding-bottom: 6px;
padding-left: 14px;
background:${props=>props.color};
`
const A = styled.div`

height: 198px;
angle: 0 deg;
opacity: 1;
border-radius: 32px;
padding: 32px;
border: 1.32px solid #FFFFFF4D;
box-shadow: 0px 0px 40px 0.66px #0000000F;
background: #FFFFFF;
border-width: 1.32px;
`
const A1 = styled.div`
gap:32px;
display:flex;
flex-direction:column;
`
const A1Txt = styled.p`
font-family: PP Mori;
font-weight: 500;
font-style: Medium;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
margin:0;
color: #2F323799;

`
const A1Txt3 = styled.p`
font-family: PP Mori;
font-weight: 800;
font-style: ExtraBold;
font-size: 12px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
text-transform: uppercase;
margin:0;
color: #202327;
`
const A1Txt2 = styled.p`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 24px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
vertical-align: bottom;
margin:0;
color: #202327;`